const input = {
    username: 'Kullanıcı Adı',
    password: 'Şifre',
    email: 'E-posta Adresi',
    phone_number: 'Telefon Numarası',
    confirm_password: 'Şifreyi Doğrula',
    search_region_code: 'Bölge kodunu ara',
    backup_code: 'Yedek kod',
    label_with_optional: '{{label}} (İsteğe bağlı)',
};
export default Object.freeze(input);
